import { Grid, Typography } from "@mui/material"
import COLORS from "../../common/FortesColors"

export default function DrawerHeader(props: {
  title: string
  onClose: () => void
  onReload: () => void
}): JSX.Element {
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      sx={{ marginBlockEnd: "20px", marginBlockStart: "20px" }}
    >
      <Typography
        paddingRight="0px"
        color={COLORS.darkPurple}
        fontSize={"120%"}
        fontWeight={600}
        maxWidth="220px"
        maxHeight="33px"
      >
        {props.title}
      </Typography>
    </Grid>
  )
}
